import { EDTFTypeTranslations } from './edtf-type-translations.entity';

export const DefaultEDTFTypeTranslations: EDTFTypeTranslations = {
    DATE_COMPLETE: 'Full date',
    DATE_PRECISION_YEAR_AND_MONTH: 'Year and month',
    DATE_PRECISION_YEAR: 'Year',
    DATETIME_COMPLETE: 'Full date and time',
    DATETIME_COMPLETE_UTC: 'Full date and time (UTC)',
    DATETIME_COMPLETE_SHIFT: 'Full date and time with shift',
    TIME_INTERVAL: 'Time interval',
    LETTER_PREFIXED_YEAR: 'Letter prefixed year',
    SEASONS: 'Year and season',
    DATE_QUALIFICATION_UNCERTAIN: 'Date uncertain',
    DATE_QUALIFICATION_APPROXIMATE: 'Date approximation',
    DATE_QUALIFICATION_UNCERTAIN_APPROXIMATE: 'Date uncertain approximation',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DECADE: 'Unspecified decade',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_CENTURY: 'Unspecified century',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_MONTH: 'Unspecified month',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_YEAR: 'Unspecified day in year',
    UNSPECIFIED_DIGIT_FROM_THE_RIGHT_DAY_IN_MONTH: 'Unspecified day in month',
    EXTENDED_INTERVAL_OPEN_END: 'Interval with open end',
    EXTENDED_INTERVAL_OPEN_BEGIN: 'Interval with open start',
    EXTENDED_INTERVAL_UNKNOWN_END: 'Interval with unknown end',
    EXTENDED_INTERVAL_UNKNOWN_BEGIN: 'Interval with unknown start',
    EXTENDED_INTERVAL: 'Interval with 1 unknown or uncertain date',
    NEGATIVE_CALENDER_YEAR: 'Negative calender year',
    COMPLETELY_UNSPECIFIED: 'Completely unspecified'
};
